module.exports = __webpack_public_path__ + "static/media/slider2.af04a81b.png";